import { render } from "./newsView.vue?vue&type=template&id=24591141&scoped=true&ts=true"
import script from "./newsView.vue?vue&type=script&lang=ts&config=true"
export * from "./newsView.vue?vue&type=script&lang=ts&config=true"

import "./newsView.vue?vue&type=style&index=0&id=24591141&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24591141"]])

export default __exports__